import axios from "axios";

import {
  select as RSSelect,
  call as RSCall,
  SelectEffect,
  SagaReturnType,
} from "redux-saga/effects";
import { IInitialState } from "@/types/initialState.types";
import { DO_CENTRAL_SERVICE_URL } from "../constants/AppConstants";
import { ROUTES } from "../constants/RouteConstants";
import { Dictionary } from "../types/utils.types";

const REDIRECTION_URL: Dictionary<string> = {
  401: `${DO_CENTRAL_SERVICE_URL}/login`,
  403: `${window.location.origin}${ROUTES.NOT_FOUND_ROUTE}`,
  404: `${window.location.origin}${ROUTES.NOT_FOUND_ROUTE}`,
};

// eslint-disable-next-line import/prefer-default-export
export function errorHandler(
  error: unknown,
  skipRedirect = false,
): string | null {
  if (!navigator.onLine) {
    return "You are currently offline. Please check your internet connection.";
  }
  if (axios.isAxiosError(error)) {
    const { response } = error;
    if (response?.status) {
      const { status } = response;
      // const code = response?.data?.code;
      const redirectionUrl = REDIRECTION_URL[status];
      let next;
      if ([401].includes(status)) {
        next = `?next=${window.location.href}`;
      }
      if (redirectionUrl && !skipRedirect) {
        window.location.replace(`${redirectionUrl}${next ?? ""}`);
        return null;
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const message = response?.data?.message;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      if (message) return message;
    }
  }
  return null;
}

export function* select<T>(
  selector: (state: IInitialState) => T,
): Generator<SelectEffect, T, T> {
  const slice: T = yield RSSelect(selector);
  return slice;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* call<Fn extends (...args: any[]) => any>(
  fn: Fn,
  ...args: Parameters<Fn>
) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const value: SagaReturnType<typeof fn> = yield RSCall(fn, ...args);
  return value;
}
